import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#424949";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    height: 20,
    fontStyle: "bold",
  },
  index: {
    width: "75%",
    textAlign: "center",
    fontSize: 8,
  },
  title: {
    width: "15%",
    height: 20,
    borderRightColor: borderColor,
    borderRightWidth: 0,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    fontSize: 10,
    padding: 2,
  },
  price: {
    width: "10%",
    height: 20,
    textAlign: "right",
    fontSize: 10,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    padding: 2,
  },
});

const TableRiderTotal = ({ invoice }) => {
  const discount = invoice.items.reduce(
    (accumulator, item) => accumulator + Number(item.discount),
    0
  );
  const advance = invoice.items.reduce(
    (accumulator, item) => accumulator + Number(item.advance),
    0
  );

  const totalPrice = invoice.total - discount - (advance ? advance : 0);

  return (
    <>
      <View style={styles.row}>
        <Text style={styles.index}>{}</Text>
        <Text style={styles.title}>{"SubTotal: "}{invoice?.items[0]?.currency}</Text>
        <Text style={styles.price}>{Number(invoice.total).toFixed(2)}</Text>
      </View>
      {discount && discount > 0 && (
        <View style={styles.row}>
          <Text style={styles.index}>{}</Text>
          <Text style={styles.title}>{"Descuento: "}{invoice?.items[0]?.currency}</Text>
          <Text style={styles.price}>{discount.toFixed(2)}</Text>
        </View>
      )}

      {advance && advance > 0 && (
        <View style={styles.row}>
          <Text style={styles.index}>{}</Text>
          <Text style={styles.title}>{"Adelanto: "}{invoice?.items[0]?.currency}</Text>
          <Text style={styles.price}>{advance.toFixed(2)}</Text>
        </View>
      )}

      <View style={styles.row}>
        <Text style={styles.index}>{}</Text>
        <Text style={styles.title}>{"Total Pagar: "}{invoice?.items[0]?.currency}</Text>
        <Text style={styles.price}>{totalPrice.toFixed(2)}</Text>
      </View>
    </>
  );
};

export default TableRiderTotal;
